import { render, staticRenderFns } from "./AdmissionAssignCard.vue?vue&type=template&id=75064b4f&scoped=true&"
import script from "./AdmissionAssignCard.vue?vue&type=script&lang=js&"
export * from "./AdmissionAssignCard.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionAssignCard.vue?vue&type=style&index=0&id=75064b4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75064b4f",
  null
  
)

export default component.exports